export * from "@vaadin/badge/vaadin-badge.js";
export * from './generated/Badge.js';
